export default {"src":"/fly/_next/static/media/br.c23d802d.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};